export default {"src":"/_next/static/media/gray-tiktok.9a27742f.svg","height":24,"width":24};